export const CASES = {
    UPDATE_CONTACTS: 'UPDATE_CONTACTS',
    UPDATE_CONTACTS_FILTER_FORM: 'UPDATE_CONTACTS_FILTER_FORM',
    CLEAR_CONTACTS: 'CLEAR_CONTACTS',
};
